import { charLimitMessage } from "@/lib/utils";

interface CharLimitMessageProps {
  value?: string | null;
  max: number;
  className?: string;
}

// Shown once a field reaches its max length (the input's maxLength stops further typing).
export function CharLimitMessage({ value, max, className = "" }: CharLimitMessageProps) {
  if ((value || "").length < max) return null;
  return (
    <p className={`mt-1 text-sm text-red-600 ${className}`}>
      {charLimitMessage(max)}
    </p>
  );
}

export default CharLimitMessage;
